// Import necessary Material-UI components for styling and layout
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
// Import lodash for utility functions
import _ from "lodash";
// Import custom components for displaying item details, approval details, and images
import {
  ApprovalDetails,
  ViewImage,
  ItemListTableItemDetails,
} from "../../common";
import { SupplierDetails } from "../../sampleControl";

export function ItemDetailsDialog({ rowData, open, handleClose }) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      sx={{ height: "90%" }}
    >
      <DialogTitle>Item Details</DialogTitle>

      <DialogContent>
        <Box>
          {/* Display item details, excluding certain fields */}
          <ItemListTableItemDetails
            cellValues={_.omit(rowData, [
              "requesterSampleImage",
              "procurementApproval",
              "supplierList",
              "id",
              "_id",
            ])}
          />
          {/* Display reference image(s) if available */}
          {rowData.requesterSampleImage && (
            <Grid
              container
              style={{
                fontSize: "14px",
                marginBottom: "15px",
              }}
            >
              <Grid item xs={12} sm={5}>
                <span>Reference Image(s):</span>
              </Grid>
              <Grid item xs={12} sm={7}>
                {Array.isArray(rowData.requesterSampleImage) ? (
                  rowData.requesterSampleImage.map((image, index) => {
                    return (
                      <ViewImage
                        productImage={image}
                        key={index}
                        altIndex={index}
                      />
                    );
                  })
                ) : (
                  <ViewImage productImage={rowData.requesterSampleImage} />
                )}
              </Grid>
            </Grid>
          )}
          {/* Display supplier details if available */}
          {rowData.supplierList && (
            <SupplierDetails
              supplierValues={rowData.supplierList}
              sampleRequestID={rowData.sampleRequestID}
              sampleItemID={rowData.sampleItemID}
            />
          )}
          {/* Display user approval details if available */}
          {rowData.userApproval && (
            <Grid item xs={12} sm={12} mt={2}>
              <Typography
                style={{
                  fontSize: "16px",
                  marginBottom: "15px",
                  marginTop: "10px",
                }}
                gutterBottom
              >
                <b>Chef Approval:</b>
              </Typography>

              <ApprovalDetails data={rowData.userApproval} />
            </Grid>
          )}
          {/* Display executive chef approval details if available */}
          {rowData.execChefApproval && (
            <Grid item xs={12} sm={12} mt={2}>
              <span>
                <b>Executive Chef Approval:</b>
              </span>
              <ApprovalDetails data={rowData.execChefApproval} />
            </Grid>
          )}
          {/* Display HOD approval details if available */}
          {rowData.HODApproval && (
            <Grid item xs={12} sm={12} mt={2}>
              <span>
                <b>HOD Approval:</b>
              </span>
              <ApprovalDetails data={rowData.HODApproval} />
            </Grid>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        {/* Button to close the dialog */}
        <Button onClick={handleClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
